import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import router from '@/router/router';
import PostWallModule from './modules/PostWall/index';
import AlbumModule from './modules/Album/Album';
import EditPostModule from './modules/EditPost/EditPost';
import NoticeMessageModule from './modules/NoticeMessage/NoticeMessage';
import OnePostModule from './modules/OnePost/OnePost';
import PostReplyListModule from './modules/SharedComponents/PostReplyList/PostReplyList';
import thirdPartyLoginModule from '@/store/modules/ThirdPartyLogin/thirdPartyLogin.js'; // @第三方登入: 引入 Module
Vue.use(Vuex);
import Loading from 'quasar/src/plugins/Loading.js';;

// @第三方登入: 取用 cookie
function getCookie(name) {
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return match[2];
}
export default new Vuex.Store({
  state: {
    token: '',
    // session 是否已存入?
    setSessionStatus: false,
    // session 存入的類型
    setSessionType: '',
    // 執行存 session 是否有發生失敗狀態
    isSetSessionWrong: false,
    // 開啟視窗，主要用來判斷動態效果
    isOpenWindow: false,
    // 開啟註冊視窗
    isOpenRegister: false,
    // 是否顯示遮擋塊
    isLogin: true,
    // 登入帳號密碼成功否
    isLoginSuccess: false,
    // 註冊時的狀態
    isRegisterSuccess: false,
    // 註冊時錯誤狀態
    isRegisterFalse: '',
    // model 是否顯示
    showModal: false,
    // 顯示 modal 的類型
    modalType: '',
    // 此使用者資訊
    userInfo: {
      HeadShot: require('@/assets/img/defultPerson1.png'),
      NickName: '',
      ReplyerLaleId: ''
    }
  },
  getters: {
    // 取得token
    getToken: state => {
      return state.token;
    },

    // 取得目前 session 存的種類
    getSessionType: state => {
      return state.setSessionType;
    },

    // 取得使用者資訊
    getUserInfo: state => {
      return state.userInfo;
    },

    // session 是否已存入
    getIsSetSession: state => {
      return state.setSessionStatus;
    },

    // 取得存 session 時是否發生錯誤
    getIsSetSessionWrong: state => {
      return state.isSetSessionWrong;
    }
  },
  mutations: {
    // 存下用戶的登入資訊至 vuex
    setUserInfo(state, payload) {
      const token = payload.token;
      state.token = token;
      localStorage.setItem('laleToken', token);
    },
    // 是否顯示 Modal，要顯示什麼 modalType
    SET_SHOW_MODAL(state, { isShow, modalName }) {
      state.showModal = isShow;
      state.modalType = modalName;
    },
    // 註冊時錯誤狀態
    SET_REGISTER_FALSE_STATUS(state, payload) {
      state.isRegisterFalse = payload;
    },
    // 註冊時的狀態
    SET_REGISTER(state, payload) {
      state.isRegisterSuccess = payload;
    },

    // PC端登出
    SET_LOGOUT(state) {
      state.userInfo = {};
      localStorage.removeItem('laleToken');
      localStorage.removeItem('userInfo');
      // @第三方登入: google 登出方法
      // if (getCookie('G_AUTHUSER_H') !== null) {
      //   const auth2 = window.gapi.auth2.getAuthInstance();
      //   auth2.signOut().then(() => {
      //     console.log('Google User signed out.');
      //   });
      // }
      location.reload();
    },
    // 登入帳號密碼成功否
    SET_LOGIN_SUCCESS(state, payload) {
      state.isLoginSuccess = payload;
    },

    // 是否顯示遮擋塊
    SET_LOGIN_STATUS(state, payload) {
      state.isLogin = payload;
    },

    // 存下 token
    SET_TOKEN(state, payload) {
      state.token = payload.token;
      state.setSessionStatus = true;
      state.setSessionType = payload.routerName;
    },

    // 存使用者資訊
    SET_USER_INFO(state, payload) {
      state.userInfo = payload;
    },

    // 存 session 發生錯誤時為 true
    SET_SESSION_WRONG(state, payload) {
      state.isSetSessionWrong = payload;
    },
    // 開啟視窗
    SET_OPEN_WINDOW_STATUS(state, payload) {
      state.isOpenWindow = payload;
    },
    // 開啟註冊視窗
    SET_OPEN_REGISTER_STATUS(state, payload) {
      state.isOpenRegister = payload;
    }
  },
  actions: {
    //註冊
    Register(context, payload) {
      Loading.show();
      const api = `${process.env.VUE_APP_API_PATH}/lale/register`;
      axios
        .post(api, payload)
        .then(res => {
          if (res.data.success && res.data.code === 200) {
            context.commit('SET_REGISTER', true);
          }
          console.log('註冊狀態', res.data.errorMessage);
          console.log('註冊狀態', res.data);
          context.commit('SET_REGISTER_FALSE_STATUS', '');
          context.commit('SET_REGISTER_FALSE_STATUS', res.data.errorMessage);
          Loading.hide();
        })
        .catch(error => {
          console.error(error);
        });
    },
    // PC端登入
    login(context, payload) {
      Loading.show();
      const password = payload.password;
      const username = payload.username;
      const api = `${process.env.VUE_APP_API_PATH}/lale/authenticate.do`;
      axios
        .post(api, { password, username })
        .then(res => {
          if (res.data.success && res.data.code === 200) {
            // console.log('登入成功', res.data.data);
            const token = res.data.data.token;
            localStorage.setItem('laleToken', token);
            console.log('PC登入撈token', token);
            context.dispatch('setTokenToSession', token);
            context.dispatch('getApiUserInfo');
            context.commit('SET_LOGIN_STATUS', false);

            // 手機使用者從官方點入進入時的router判斷
            // var screenWidth = screen.width;
            // if (screenWidth > 768) {
            //   router.push({ name: 'Home' });
            // } else {
            //   router.replace({ name: 'PostWall' });
            //   location.replace(location);
            // }
            Loading.hide();
            // location.reload();
          } else {
            console.log('res', res.data.errorMessage);
            context.commit('SET_LOGIN_SUCCESS', true);
            Loading.hide();
          }
        })
        .catch(error => {
          console.error(error);
        });
    },

    // Lale QRcdoe登入
    qrCodeLoginValid(context, { uuid }) {
      // const api = `${process.env.VUE_APP_LALE_PATH}/customers/lale/app/login/valid-info/${uuid}`;
      const api = `${process.env.VUE_APP_TOKEN_POOLS_PATH}/user/qr/valid-info`;
      axios
        .post(api, { uuid })
        .then(async response => {
          console.log('qrCodeLoginValid', response.data);
          if (response.data.status === 200) {
            // console.log('QRcdoe登入', response.data);
            const token = response.data.data.token;
            localStorage.setItem('laleToken', token);
            context.dispatch('setTokenToSession', token);
            context.dispatch('getApiUserInfo');
            context.commit('SET_LOGIN_STATUS', false);
            context.commit('SET_SHOW_MODAL', false);
          } else {
            context.commit('SET_LOGIN_SUCCESS', true);
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    // 存 顯示所有有權限觀看的貼文 token 到 session
    setTokenToSession(context, payload) {
      let token = payload.token || localStorage.getItem('laleToken');
      let api = `${process.env.VUE_APP_API_PATH}/gawbue/${token}`;
      if (payload.routerName === 'MyPost' || payload.routerName === 'Album') {
        // 判斷裝置
        const myUserAgent = navigator.userAgent;
        let isiOS = !!myUserAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        const mobileType = isiOS ? 'ios' : 'android';
        // 我的主頁:只撈取自己貼文的資料
        api = `${process.env.VUE_APP_API_PATH}/gawbuebyme/${token}/${mobileType}`;
      } else if (payload.routerName === 'FriendPost') {
        // 朋友的主頁:只撈取該名朋友的貼文資料
        api = `${process.env.VUE_APP_API_PATH}/gawbue/${payload.fid}/${token}`;
      }
      axios
        .get(api)
        .then(response => {
          let sessionPayload = {
            token,
            routerName: payload.routerName
          };
          context.dispatch('getApiUserInfo');
          context.commit('SET_TOKEN', sessionPayload);
          localStorage.setItem('laleToken', token);
          console.log(`token 存入 ${payload.routerName} session`);
        })
        .catch(error => {
          context.commit('SET_SESSION_WRONG', true);
          console.error(error);
        });
    },
    // 拿user資料
    getApiUserInfo(context) {
      let api = `${process.env.VUE_APP_API_PATH}/getUserInfo`;
      axios
        .post(api)
        .then(response => {
          localStorage.setItem('userInfo', JSON.stringify(response.data));
          context.commit('SET_USER_INFO', response.data);
          console.log('拿user資料');
          console.log(response.data);
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 拿小鈴鐺通知
    callNoticeMessage() {
      let api = `${process.env.VUE_APP_API_PATH}/getNoticeCount`;
      axios
        .post(api)
        .then(res => {
          // 判斷裝置
          const myUserAgent = navigator.userAgent;
          let isiOS = !!myUserAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
          // console.log(res.data.NoticeNumber);
          let noticeNumber = '0';
          noticeNumber = res.data.NoticeNumber;
          // if (isiOS) {
          //   window.webkit.messageHandlers.setNotificationBell.postMessage(noticeNumber);
          // } else {
          //   window.LaleTon.setNotificationBell(noticeNumber);
          // }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  modules: {
    PostWallModule,
    EditPostModule,
    AlbumModule,
    NoticeMessageModule,
    OnePostModule,
    PostReplyListModule,
    thirdPartyLoginModule
  }
});
